var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snap-nav-wrap"},[_vm._t("before"),_vm._v(" "),_c('ul',{ref:"nav",staticClass:"snap-nav"},[_vm._t("default"),_vm._v(" "),(_vm.inkbar && _vm.activeIndex !== -1)?_c('li',{staticClass:"snap-ink-bar",class:{
        trans: _vm.readyTrans
      },style:(_vm.barStyle)}):_vm._e()],2),_vm._v(" "),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }